export default __webpack_public_path__ + "5d128134c7a4d6d7acd5c0c4752ac24e.png";